export default function initContactForm() {
  const form = document.querySelector('[data-contact-form]');
  const config = window.vizaAzContact;

  if (!form || !config || !config.ajaxUrl || !window.fetch) {
    return;
  }

  const notice = document.querySelector('[data-contact-notice]');
  const submit = form.querySelector('[type="submit"]');
  const submitText = form.querySelector('[data-contact-submit-text]');
  const defaultSubmitText = submitText ? submitText.textContent : '';

  const showNotice = (message, success) => {
    if (!notice) {
      return;
    }

    notice.textContent = message;
    notice.hidden = false;
    notice.classList.toggle('contact-form__notice--success', success);
    notice.classList.toggle('contact-form__notice--error', !success);
    notice.setAttribute('role', success ? 'status' : 'alert');
    notice.scrollIntoView({ behavior: 'auto', block: 'nearest' });
  };

  const resetTurnstile = () => {
    if (window.turnstile && typeof window.turnstile.reset === 'function') {
      window.turnstile.reset();
    }
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (submit && submit.disabled) {
      return;
    }

    if (!form.reportValidity()) {
      return;
    }

    if (notice) {
      notice.hidden = true;
    }

    form.setAttribute('aria-busy', 'true');
    if (submit) {
      submit.disabled = true;
    }
    if (submitText) {
      submitText.textContent = config.sendingText;
    }

    try {
      const response = await window.fetch(config.ajaxUrl, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const result = await response.json();
      const message = result && result.data && result.data.message
        ? result.data.message
        : config.errorText;

      if (!response.ok || !result.success) {
        throw new Error(message);
      }

      showNotice(message, true);
      form.reset();
      resetTurnstile();
    } catch (error) {
      showNotice(error.message || config.errorText, false);
      resetTurnstile();
    } finally {
      form.removeAttribute('aria-busy');
      if (submit) {
        submit.disabled = false;
      }
      if (submitText) {
        submitText.textContent = defaultSubmitText;
      }
    }
  });
}
